var map = {
	"app/pages/attendances/attendances.module": [
		"../../../../../src/app/pages/attendances/attendances.module.ts",
		"common"
	],
	"app/pages/employees/employees.module": [
		"../../../../../src/app/pages/employees/employees.module.ts",
		"common",
		"employees.module"
	],
	"app/pages/home/home.module": [
		"../../../../../src/app/pages/home/home.module.ts",
		"common",
		"home.module"
	],
	"app/pages/reports/reports.module": [
		"../../../../../src/app/pages/reports/reports.module.ts",
		"reports.module"
	],
	"app/pages/settings/settings.module": [
		"../../../../../src/app/pages/settings/settings.module.ts",
		"common",
		"settings.module"
	],
	"app/pages/setup/setup.module": [
		"../../../../../src/app/pages/setup/setup.module.ts",
		"common",
		"setup.module"
	],
	"app/pages/sub-admin/sub-admin.module": [
		"../../../../../src/app/pages/sub-admin/sub-admin.module.ts",
		"sub-admin.module"
	],
	"app/pages/system/system.module": [
		"../../../../../src/app/pages/system/system.module.ts",
		"system.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = "../../../../../src/$$_gendir lazy recursive";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/$$_gendir lazy
// module id = ../../../../../src/$$_gendir lazy recursive
// module chunks = main